import { render, staticRenderFns } from "./loanMoney.vue?vue&type=template&id=80e431ce&scoped=true&"
import script from "./loanMoney.vue?vue&type=script&lang=js&"
export * from "./loanMoney.vue?vue&type=script&lang=js&"
import style0 from "./loanMoney.vue?vue&type=style&index=0&id=80e431ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80e431ce",
  null
  
)

export default component.exports